export { default, StyledErrorState } from './ErrorState';
export type { ErrorStateProps } from './ErrorState';
